if (!customElements.get('rd-cart-quick-add')) {
  customElements.define('rd-cart-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.variants = JSON.parse(this.querySelector('[data-empty-variants]').textContent);
      this.form = this.querySelector('form');
      this.optionGroups = [...this.querySelectorAll('[data-empty-option-group]')];
      this.optionInputs = [...this.querySelectorAll('[data-empty-option-group] input')];
      this.button = this.querySelector('[type="submit"]');
      this.status = this.querySelector('[role="status"]');
      this.addEventListener('change', event => {
        event.stopPropagation();
        this.updateSelection();
      });
      this.form.addEventListener('submit', event => this.add(event));
      this.updateSelection();
    }

    updateSelection() {
      const values = this.optionGroups.map(group => group.querySelector('input:checked')?.value || '');
      this.variant = this.optionGroups.length
        ? this.variants.find(variant => variant.options.every((value, index) => value === values[index]))
        : this.variants[0];
      this.form.querySelector('[name="id"]').value = this.variant?.id || '';
      this.button.disabled = this.busy || !this.variant?.available;
      this.optionGroups.forEach((group, index) => {
        group.querySelectorAll('input').forEach(option => {
          option.disabled = this.busy || !this.variants.some(variant => variant.available && variant.options[index] === option.value &&
            values.every((value, other) => other === index || !value || variant.options[other] === value));
        });
      });
      if (this.variant) this.querySelector('[data-empty-price]').textContent = this.variant.price;
    }

    async add(event) {
      event.preventDefault();
      if (this.busy || !this.variant?.available) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.optionInputs.forEach(input => { input.disabled = true; });
      this.status.hidden = false;
      this.status.textContent = this.dataset.adding;
      const drawer = document.querySelector('cart-drawer');
      const pageItems = document.querySelector('cart-items');
      const pageItemsId = document.getElementById('main-cart-items')?.dataset.id;
      const footer = document.getElementById('main-cart-footer');
      const sectionIds = [...new Set([
        ...(drawer ? drawer.getSectionsToRender().map(section => section.id) : ['cart-icon-bubble']),
        pageItemsId, footer?.dataset.id
      ].filter(Boolean))];
      let added = false;
      let errorMessage = this.dataset.error;
      try {
        const body = new FormData(this.form);
        body.append('sections', sectionIds.join(','));
        body.append('sections_url', window.location.pathname);
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          errorMessage = data.description || errorMessage;
          throw new Error(errorMessage);
        }
        added = true;
        if (sectionIds.some(id => !data.sections?.[id])) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        if (pageItems && pageItemsId) {
          const next = new DOMParser().parseFromString(data.sections[pageItemsId], 'text/html').querySelector('cart-items');
          if (!next) throw new Error('Missing cart section');
          pageItems.replaceWith(next);
        }
        if (footer) {
          const next = new DOMParser().parseFromString(data.sections[footer.dataset.id], 'text/html').querySelector('#main-cart-footer');
          if (!next) throw new Error('Missing cart footer');
          footer.querySelector('.js-contents').innerHTML = next.querySelector('.js-contents').innerHTML;
          footer.classList.toggle('is-empty', next.classList.contains('is-empty'));
          const checkout = footer.querySelector('[name="checkout"]');
          if (checkout) checkout.disabled = !!next.querySelector('[name="checkout"]')?.disabled;
        }
        if (drawer) {
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          requestAnimationFrame(() => trapFocus(drawer.querySelector('.drawer__inner'), drawer.querySelector('.drawer__close')));
        } else if (!pageItems) {
          window.location.assign(window.routes.cart_url);
          return;
        } else {
          const bubble = document.getElementById('cart-icon-bubble');
          const nextBubble = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && nextBubble) bubble.innerHTML = nextBubble.innerHTML;
          const heading = document.querySelector('cart-items h1');
          heading?.setAttribute('tabindex', '-1');
          heading?.focus();
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: this.variant.id, cartData: data });
        window.RDCartUpsell?.init();
      } catch (error) {
        if (added) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        this.status.textContent = errorMessage;
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.updateSelection();
      }
    }
  });
}
